import { lazy, FC, Suspense } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper'
import { getCSSVariableValue } from '../../_metronic/assets/ts/_utils'
import { WithChildren } from '../../_metronic/helpers'
// import { onForegroundMessage } from '../../_metronic/helpers/notification'
import { RequirePermission } from './RequirePermission'
const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
const ServicePage = lazy(() => import('../pages/services/ServicesWrapper'))
const DispatchMapWrapper = lazy(() => import('../pages/dispatchMap/DispatchMapWrapper'))
const OperationalZonesWrapper = lazy(
  () => import('../pages/operationalZones/OperationalZonesWrapper'),
)
const OperationalZonesCityWrapper = lazy(
  () => import('../pages/operationalZones/OperationalZonesCityWrapper'),
)
const CategoryPage = lazy(() => import('../pages/category/CategoryWrapper'))
const ProductPage = lazy(() => import('../pages/product/ProductWrapper'))
const ProductsGroupPage = lazy(
  () => import('../pages/productsGroup/ProductsGroupWrapper'),
)
const CompanyEmployeePage = lazy(
  () => import('../pages/manageUsers/companyEmployee/CompanyEmployeeWrapper'),
)
const RolesPage = lazy(() => import('../pages/roles/RolesWrapper'))
const CopilotPage = lazy(() => import('../pages/copilot/CopilotWrapper'))
const ConsumerPage = lazy(
  () => import('../pages/manageUsers/consumer/ConsumerWrapper'),
)
const ProviderPage = lazy(
  () => import('../pages/manageUsers/provider/ProviderWrapper'),
)
const ProviderDetailPage = lazy(
  () => import('../pages/manageUsers/provider/ProviderDetailWrapper'),
)
const ProviderStaffListPage = lazy(
  () => import('../pages/manageUsers/provider/StaffListWrapper'),
)

const BookingPage = lazy(() => import('../pages/booking/BookingWrapper'))
const StaffCalendarPage = lazy(
  () => import('../pages/staffCalendar/StaffCalendarWrapper'),
)

const AccountListPage = lazy(() => import('../pages/account/AccountWrapper'))
const RatingsPage = lazy(() => import('../pages/ratings/pages/RatingsPage'))
const BookingDetailPage = lazy(
  () => import('../pages/booking/BookingDetailWrapper'),
)

const PaymentTransactionPage = lazy(
  () => import('../pages/paymentTransaction/paymentTransactionWrapper'),
)

const Banners = lazy(() => import('../pages/banner/BannerWrapper'))
const Offers = lazy(() => import('../pages/offers/OffersWrapper'))

const TransactionPage = lazy(
  () => import('../pages/transaction/TransactionWrapper'),
)

const Commission = lazy(() => import('../pages/commission/CommissionWrapper'))
const QuestionarePage = lazy(
  () => import('../pages/questionare/QuestionareWrapper'),
)
const PromoCodePage = lazy(() => import('../pages/promo-code/PromoCodeWrapper'))
const NotificationsPage = lazy(
  () => import('../pages/notification/NotificationPage'),
)
const NotificationRulesPage = lazy(
  () => import('../pages/notificationRules/NotificationRulesWrapper'),
)
const BlogPage = lazy(() => import('../pages/blog/BlogWrapper'))

const AnnouncementPage = lazy(
  () => import('../pages/announcement/AnnouncementWrapper'),
)

const PromoDiscountPage = lazy(
  () => import('../pages/discounts/PromoDiscountPage'),
)
const DiscountRulesPage = lazy(
  () => import('../pages/discounts/DiscountRulesPage'),
)
const ProviderAgreementsPage = lazy(
  () => import('../pages/discounts/_ProviderAgreementsPage'),
)
const CampaignsPage = lazy(() => import('../pages/discounts/_CampaignsPage'))
const RedemptionsPage = lazy(() => import('../pages/discounts/RedemptionsPage'))
const TipsPage = lazy(() => import('../pages/tips/TipsPage'))
const CampaignTrackingPage = lazy(
  () => import('../pages/campaign-tracking/CampaignTrackingPage'),
)
const CartCustomerPage = lazy(() => import('../pages/cart/CustomerCartPage'))
const WalletManagementWrapper = lazy(() => import('../pages/walletManagement/WalletManagementWrapper'))
const WalletWithdrawWrapper = lazy(() => import('../pages/walletWithdraw/WalletWithdrawWrapper'))

// Reports & Analytics. Lazy because it pulls in ApexCharts and Leaflet, neither
// of which should be in the bundle for someone who only ever opens Bookings.
// Daily support report, listed under the Support sidebar menu.
const DailySupportReportWrapper = lazy(
  () => import('../pages/dailySupportReport/DailySupportReportWrapper'),
)
const SupportPlaybookWrapper = lazy(
  () => import('../pages/supportPlaybook/SupportPlaybookWrapper'),
)
const ReportsWrapper = lazy(() => import('../pages/reports/ReportsWrapper'))
const CancellationReasonsPage = lazy(
  () => import('../pages/reports/CancellationReasonsPage'),
)

const PrivateRoutes = () => {
  //* for future use
  // const navigate = useNavigate()

  // useEffect(() => {
  //     onForegroundMessage(navigate)
  //     // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [])
  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route
          path='services'
          element={
            <RequirePermission allOf={['catalog.read']}>
              <ServicePage />
            </RequirePermission>
          }
        />
        <Route
          path='dispatch-map'
          element={
            <RequirePermission allOf={['bookings.read', 'operationalZones.read']}>
              <DispatchMapWrapper />
            </RequirePermission>
          }
        />
        <Route
          path='operational-zones-city'
          element={
            <RequirePermission allOf={['operationalZones.read']}>
              <OperationalZonesCityWrapper />
            </RequirePermission>
          }
        />
        <Route
          path='operational-zones/:cityId/:cityName/zones'
          element={
            <RequirePermission allOf={['operationalZones.read']}>
              <OperationalZonesWrapper />
            </RequirePermission>
          }
        />
        <Route
          path='service/:serviceId/category'
          element={
            <RequirePermission allOf={['catalog.read']}>
              <CategoryPage />
            </RequirePermission>
          }
        />
        <Route
          path='products'
          element={
            <RequirePermission allOf={['catalog.read']}>
              <ProductPage />
            </RequirePermission>
          }
        />
        <Route
          path='product-group'
          element={
            <RequirePermission allOf={['catalog.read']}>
              <ProductsGroupPage />
            </RequirePermission>
          }
        />
        <Route
          path='manage-user/company-employee'
          element={
            <RequirePermission allOf={['adminUsers.read']}>
              <CompanyEmployeePage />
            </RequirePermission>
          }
        />
        <Route
          path='roles'
          element={
            <RequirePermission superAdminOnly>
              <RolesPage />
            </RequirePermission>
          }
        />
        <Route
          path='genie-ai'
          element={
            <RequirePermission superAdminOnly>
              <CopilotPage />
            </RequirePermission>
          }
        />
        <Route
          path='manage-user/consumer'
          element={
            <RequirePermission allOf={['users.read']}>
              <ConsumerPage />
            </RequirePermission>
          }
        />
        <Route
          path='manage-user/provider'
          element={
            <RequirePermission allOf={['providers.read']}>
              <ProviderPage />
            </RequirePermission>
          }
        />
        <Route
          path='manage-user/provider/:id'
          element={
            <RequirePermission allOf={['providers.read']}>
              <ProviderDetailPage />
            </RequirePermission>
          }
        />
        <Route
          path='manage-user/provider/:id/staff'
          element={
            <RequirePermission allOf={['staff.read']}>
              <ProviderStaffListPage />
            </RequirePermission>
          }
        />
        <Route
          path='booking'
          element={
            <RequirePermission allOf={['bookings.read']}>
              <BookingPage />
            </RequirePermission>
          }
        />
        <Route
          path='staff-calendar'
          element={
            <RequirePermission allOf={['bookings.read']}>
              <StaffCalendarPage />
            </RequirePermission>
          }
        />
        <Route
          path='wallet-management'
          element={
            <RequirePermission allOf={['wallet.read']}>
              <WalletManagementWrapper />
            </RequirePermission>
          }
        />
        <Route
          path='wallet-withdraw'
          element={
            <RequirePermission allOf={['wallet.read']}>
              <WalletWithdrawWrapper />
            </RequirePermission>
          }
        />
        <Route
          path='account'
          element={
            <RequirePermission allOf={['payments.read']}>
              <AccountListPage />
            </RequirePermission>
          }
        />
        <Route
          path='payment-transaction'
          element={
            <RequirePermission allOf={['transactions.read']}>
              <PaymentTransactionPage />
            </RequirePermission>
          }
        />
        <Route
          path='tips'
          element={
            <RequirePermission allOf={['tips.read']}>
              <TipsPage />
            </RequirePermission>
          }
        />
        <Route
          path='ratings'
          element={
            <RequirePermission allOf={['ratings.read']}>
              <RatingsPage />
            </RequirePermission>
          }
        />
        <Route
          path='booking/:bookingId'
          element={
            <RequirePermission allOf={['bookings.read']}>
              <BookingDetailPage />
            </RequirePermission>
          }
        />
        <Route
          path='banner-management'
          element={
            <RequirePermission allOf={['banners.read']}>
              <Banners />
            </RequirePermission>
          }
        />
        <Route
          path='offers'
          element={
            <RequirePermission allOf={['offers.read']}>
              <Offers />
            </RequirePermission>
          }
        />
        <Route
          path='transaction'
          element={
            <RequirePermission allOf={['transactions.read']}>
              <TransactionPage />
            </RequirePermission>
          }
        />
        <Route
          path='commission'
          element={
            <RequirePermission allOf={['commission.read']}>
              <Commission />
            </RequirePermission>
          }
        />
        <Route
          path='questionare'
          element={
            <RequirePermission allOf={['questionnaire.read']}>
              <QuestionarePage />
            </RequirePermission>
          }
        />
        <Route
          path='promo-code'
          element={
            <RequirePermission allOf={['promos.read']}>
              <PromoCodePage />
            </RequirePermission>
          }
        />
        <Route path='notifications' element={<NotificationsPage />} />
        <Route
          path='announcement'
          element={
            <RequirePermission allOf={['announcements.read']}>
              <AnnouncementPage />
            </RequirePermission>
          }
        />
        <Route
          path='notification-rules'
          element={
            <RequirePermission allOf={['notificationRules.read']}>
              <NotificationRulesPage />
            </RequirePermission>
          }
        />
        <Route
          path='blogs'
          element={
            <RequirePermission allOf={['blogs.read']}>
              <BlogPage />
            </RequirePermission>
          }
        />
        <Route
          path='customers-cart'
          element={
            <RequirePermission allOf={['users.read']}>
              <CartCustomerPage />
            </RequirePermission>
          }
        />

        {/* Reports & Analytics. The tab is a route parameter so a report can be
            linked to and reloaded, rather than always landing on the overview. */}
        <Route
          path='reports'
          element={
            <RequirePermission allOf={['reports.read']}>
              <SuspensedView>
                <ReportsWrapper />
              </SuspensedView>
            </RequirePermission>
          }
        />
        <Route
          path='reports/:tab'
          element={
            <RequirePermission allOf={['reports.read']}>
              <SuspensedView>
                <ReportsWrapper />
              </SuspensedView>
            </RequirePermission>
          }
        />
        <Route
          path='daily-support-report'
          element={
            <RequirePermission allOf={['reports.read', 'reports.revenue.read']}>
              <SuspensedView>
                <DailySupportReportWrapper />
              </SuspensedView>
            </RequirePermission>
          }
        />
        <Route
          path='support-playbook'
          element={
            <RequirePermission allOf={['supportPlaybook.read']}>
              <SuspensedView>
                <SupportPlaybookWrapper />
              </SuspensedView>
            </RequirePermission>
          }
        />
        <Route
          path='cancellation-reasons'
          element={
            <SuspensedView>
              <CancellationReasonsPage />
            </SuspensedView>
          }
        />

        {/* <Route path='discounts/promo' element={<PromoDiscountPage />} /> */}
        <Route
          path='discounts/rules'
          element={
            <RequirePermission allOf={['discounts.read']}>
              <DiscountRulesPage />
            </RequirePermission>
          }
        />
        {/* <Route path='discounts/provider-agreements' element={<ProviderAgreementsPage />} /> */}
        {/* <Route path='discounts/campaigns' element={<CampaignsPage />} /> */}
        <Route
          path='discounts/redemptions'
          element={
            <RequirePermission allOf={['discounts.read']}>
              <RedemptionsPage />
            </RequirePermission>
          }
        />
        <Route
          path='campaign-tracking'
          element={
            <RequirePermission allOf={['campaigns.read']}>
              <CampaignTrackingPage />
            </RequirePermission>
          }
        />

        {/* Lazy Modules */}
        <Route
          path='settings'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />

        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue('--kt-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export { PrivateRoutes }
